import * as React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getGenericNotifications } from '../../selectors/notifications';
import { Notification, Notifications } from '../notifications';

const ChatNotifications = () => {
  const intl = useIntl();
  /** @type {[CreateNotificationPayload]}*/
  const genericNotifications = useSelector(getGenericNotifications);

  return (
    <Notifications>
      {genericNotifications.map(({ id, state, success, error }) => {
        const { intlKey, intlValues = {} } = state === 'success' ? success : error;

        if (!intlKey) {
          return null;
        }

        const message = intl.formatMessage({ id: intlKey }, { ...intlValues });

        return (
          <Notification
            key={id}
            message={message}
            type={state}
          />
        );
      })}
    </Notifications>
  );
};

export default ChatNotifications;
